module.exports = __webpack_public_path__ + "static/media/dollar-symbol.bb3523df.svg";